const SvgMenuExpand = props => (
  <svg width={24} height={24} viewBox='0 0 24 24' {...props}>
    <path d='M20.293 14.707a.999.999 0 010-1.414L21.586 12l-1.293-1.293a.999.999 0 111.414-1.414l2 2a.999.999 0 010 1.414l-2 2a.997.997 0 01-1.414 0zM6 5h12a1 1 0 010 2H6a1 1 0 110-2zm0 6h12a1 1 0 010 2H6a1 1 0 010-2zm0 6h12a1 1 0 010 2H6a1 1 0 010-2z' />
  </svg>
);

export default SvgMenuExpand;
